'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rewards = require('./rewards');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_rewards).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/rewards/index.js
// module id = 459
// module chunks = 0